import Icon from "@material-ui/icons/Email";
import EmailLogList from "./EmailLogList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "emailSendingLogs",
  list: EmailLogList,
  icon: Icon,
};
